module.exports = __webpack_public_path__ + "img/pf.ec1b4b81.jpg";